import { Offers } from "../../components/glide";

const init = () => {
  Offers();
};

export default init;
